import { render } from "./SubscriptionsTitle.vue?vue&type=template&id=7a5221c7"
import script from "./SubscriptionsTitle.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__